import React from 'react'
import './CommingSoon.css'
import { useNavigate } from 'react-router-dom'

const CommingSoon = () => {
    const navigate = useNavigate();
  return (
    <div className="commingSoon">
        <h3>We're launching our Application</h3>
        <p>We're coming soon! Awesome Mobile app to present your future.
            We're working hard to give you the best experience!</p>
        <button onClick={()=>navigate('/')}>Back to Home</button>
    </div>
  )
}

export default CommingSoon